import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllCreatorsInterface {
  search: string;
}

export const useGetAllCreators = () => {
  const mutate = useMutation(({ search }: GetAllCreatorsInterface) => {
    return get(`/external-api/search_from_all_creators/${search}`);
  });

  return mutate;
};

export default useGetAllCreators;
